import {Button} from "../../../../index";
import React from "react";
import FinaliseConfirm from "./FinaliseConfirm";
import {useViewerStore} from "../../../../../store/store";
import {RoofMesh} from "../../../../../@types/types";

interface RoofPitchAlertProps {
    roofs : RoofMesh[]
}

const RoofPitchValidation = ({roofs} : RoofPitchAlertProps) => {

    const sceneViewer = useViewerStore(state => state.sceneViewer);


    const confirmFinalize = () => {
        sceneViewer.viewerAlert({
            show: true,
            title: "Save Design",
            message: <FinaliseConfirm/>,
            messageType: "success",
            isModal: true
        })
    }


    const cancelFinalize = () => {
        sceneViewer.viewerAlert({show: false})
    }


    return (
        <>
            <p>There is an array designed on Roof {

                roofs.map((roof) => {
                    return roof.userData.roof_tag_id
                })

            }., which has a steep pitch of {

                roofs.map((roof) => {
                    return roof.oriAng.tilt
                }).join(' ')

            } degrees
                <br/>
                <br/>
                If you wish to continue finalizing the design, click 'Confirm' below. </p>
            <br/>
            <div className={"modal-bottom-action-button-container"}>

                <Button
                    variant="btn-primary"
                    size="btn-md"
                    className="editor__control--finalize modal-confirm-button"
                    onClick={confirmFinalize}
                >
                    Confirm
                </Button>
                <Button
                    variant="btn-primary"
                    size="btn-md"
                    className="editor__control--finalize modal-cancel-button"
                    onClick={cancelFinalize}
                >
                    Cancel
                </Button>

            </div>
        </>
    )
}

export default RoofPitchValidation;